module.exports = __webpack_public_path__ + "img/zillion-whales.31af8076.svg";